import http from 'hasta-la-vista-middleware-api/http'
import {AuthService, OrderService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {
    name: 'payment',
    data () {
        return {
            msg: 'Payments',
            items: [],
            errors: [],
            txnToken: this.$route.query.txnToken,
            paymentType: this.$route.params.paymentType,
            cinemaId: null,
            vistaSessionId: null,
            vistaAmount: null,
            ticketCode: null,
            userSessionId: null,
            loggedInUser: null,
            paymentError: {extendedResultCode: undefined, errorDescription: "", Result: undefined},
            loading: true,
        }
    },

    methods: {
        validateToken() {
            if(this.txnToken.length === 64) {

                //validate the payment with fnb
                Promise.resolve(http.post('/payment/validatePayment', {
                    txnToken:this.txnToken,
                })).then(data => {
                    // console.log("data");
                    // console.log(data);
                    //check the transaction
                    //set this to true to pretend that the fnb call was successfully validated
                    let debug = false;
                    let transactionData = Promise.resolve(this.checkTransaction(data,"payment",debug)).then(transactionData => {
                        // console.log("transaction data");
                        // console.log(transactionData);
                        if(transactionData.status) {
                            // console.log("success");
                            //now tell vista the payment was successful

                            let expiryDate = transactionData.metadata[1].expiryDate;
                            let expiryArray = expiryDate.split("/");

                            Promise.all([OrderService.getOrder(),AuthService.user()]).then(([order,user]) => {
                                // console.log("Order Totals",order.total, order.totalInCents)
                                //let merchantOrderNumber = transactionData.metadata[2].merchantOrderNumber;
                                this.loggedInUser = user;

                                let paymentObject = {
                                    cardNumber:transactionData.metadata[0].maskedPan,
                                    CardType:"CARD",
                                    month:expiryArray[0],
                                    year:expiryArray[1],
                                    amount:order.totalInCents,
                                    customerName: this.loggedInUser.FullName,
                                    customerPhone: this.loggedInUser.MobilePhone,
                                    customerEmail: this.loggedInUser.Email,
                                };
                                // console.log("payment object");
                                // console.log(paymentObject);
                                //Tell vista to complete the payment
                                Promise.resolve(http.post('/payment/complete', paymentObject)).then(vistaData => {
                                    //if something goes wrong in Vista we need to reverse the FNB payment:
                                    var booking = vistaData
                                    // console.log("Booking", vistaData)
                                    if(vistaData.ExtendedResultCode > 0) {
                                        this.paymentError = {extendedResultCode: vistaData.ExtendedResultCode, errorDescription: vistaData.errorDescription, Result: vistaData.Result}

                                        var p = OrderService.pendingSession();
                                        booking.SessionDetails = Object.assign({}, p);
                                        booking.Tickets = order.Tickets;
                                        booking.Concessions = order.Concessions;
                                        booking.SessionDate = order.SessionDate;
                                        booking.paymentError = this.paymentError;
                                        OrderService.setBooking(booking);
                                        OrderService.clearPendingSessions();
                                        // console.log("Payment error", this.paymentError)
                                        this.$router.push('/booking-unsuccessful');
                                    } else {
                                        var p = OrderService.pendingSession();
                                        booking.SessionDetails = Object.assign({}, p);
                                        booking.Tickets = order.Tickets;
                                        booking.Concessions = order.Concessions;
                                        booking.SessionDate = order.SessionDate;
                                        OrderService.setBooking(booking);
                                        OrderService.clearPendingSessions();
                                        // console.log("Payment complete", booking)
                                        var bookingId = booking.data.VistaBookingNumberBase64;
                                        this.$router.push('/donation-successful/' + encodeURIComponent(bookingId));
                                    }
                                });
                            });
                        } else {
                            Promise.resolve(OrderService.getOrder()).then(order => {
                                var booking = {};
                                this.loggedInUser = JSON.parse(localStorage.getItem('ORDER_USER'));
                                this.paymentError = {extendedResultCode: transactionData.responseCode, errorDescription: transactionData.errorDescription, Result: transactionData.responseCode}
                                var p = OrderService.pendingSession();
                                booking.SessionDetails = Object.assign({}, p);
                                booking.Tickets = order.Tickets;
                                booking.Concessions = order.Concessions;
                                booking.SessionDate = order.SessionDate;
                                booking.paymentError = this.paymentError;
                                // console.log("Set Booking",booking)
                                OrderService.setBooking(booking);
                                // console.log("Payment error", this.paymentError)
                                this.$router.push('/donation-unsuccessful');
                            });
                        }
                    });
                });
            }
        },

        checkTransaction(data,type,bypass) {
            let toasterMessage = "";
            let returnStatus = false;
            let returnObject = {
                "status":returnStatus,
                "metadata":{},
            };
            // console.log("check Transaction", data, type, bypass)
            // console.log("data.data", data.data)
            data = data.data
            if(data.status || bypass) {
                let statusArray = data.status.split(":");
                // console.log("statusArray", statusArray)
                if(statusArray[0] === "APPROVED" || bypass) {
                    toasterMessage = "Transaction Approved";

                    if(type ==="payment") {
                        returnObject.status = true;
                        returnObject.metadata = data.metadata;
                    } else if(type === "reverse") {
                        returnObject.status = true;
                        toasterMessage = "Payment successfully reversed";
                    }
                } else {
                    toasterMessage = data.status;
                    returnObject.status = false;
                    returnObject.responseCode = data.responseCode
                    returnObject.errorDescription = data.status
                }

                // console.log("return Object", returnObject)
                return returnObject;
            }
        },

        validatePayment(){
            AuthService.getUserOrderInfo().then((user)=> {
                let payload = {
                    TxnToken: this.$route.query.txnToken,
                    TransactionId: this.$route.query.transaction_id,
                    TransactionStatus: this.$route.query.success,
                    CustomerName: user.FullName,
                    CustomerPhone: user.MobilePhone,
                    CustomerEmail: user.Email,
                };
                OrderService.completeOrder(payload).then(
                    (booking)=> {
                      // console.log(booking);
                      if(booking === undefined){
                        this.$router.push(`/donation-unsuccessful`)
                      }else{
                        this.$router.push(`/donation-successful/${booking.bookingId}/${booking.bookingNumber}`);
                      }
                    }
                );
            })
        },
    },

    created() {
      this.loading = true;
    },

    mounted()
    {
        if(this.paymentType === "validatePayment") {
            this.validatePayment();
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/payment/donation.js